const PROD_API_URL = 'https://func-tutortrack-api-prod.azurewebsites.net';
const STAGING_API_URL = 'https://func-tutortrack-api-staging.azurewebsites.net';
const LOCAL_API_URL = 'http://localhost:8181';

export const normalizeConfiguredApiUrl = (value?: string): string | null => {
  const trimmedValue = value?.trim();

  if (!trimmedValue) {
    return null;
  }

  try {
    return new URL(trimmedValue).toString().replace(/\/+$/, '');
  } catch {
    return null;
  }
};

export const inferApiUrlFromHostname = (hostname: string): string => {
  const normalizedHostname = hostname.toLowerCase();

  if (normalizedHostname === 'tutor.digiglobe.org' || normalizedHostname.endsWith('.azurestaticapps.net')) {
    return PROD_API_URL;
  }

  if (normalizedHostname === 'staging.tutor.digiglobe.org') {
    return STAGING_API_URL;
  }

  if (normalizedHostname === 'localhost' || normalizedHostname === '127.0.0.1') {
    return LOCAL_API_URL;
  }

  return PROD_API_URL;
};

const inferApiUrlFromWindow = (): string => {
  if (typeof window === 'undefined') {
    return LOCAL_API_URL;
  }

  return inferApiUrlFromHostname(window.location.hostname);
};

export const API_URL = normalizeConfiguredApiUrl(process.env.REACT_APP_API_URL) ?? inferApiUrlFromWindow();

export const API_BASE_URL = `${API_URL}/api`;